/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import React from "react";
import SVG from "react-inlinesvg";
import { FormattedDate, FormattedMessage, FormattedTime } from "react-intl";
import { useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_helpers";

export function QuickUser() {
  const history = useHistory();
  const { userData } = useSelector(
    (state) => ({ userData: state.auth.user }),
    shallowEqual
  );
  // "{"groupId":null,"subGroupTitle":"0","dormId":null,"blockId":null,"isDeleted":false,"username":"admin","idNumber":"123","firstName":"مهدی","lastName":"ابراهیمی","gender":"Male","nationalCode":"123","email":"student@7diamond.ir","mobile":"09122435833","barcodeNumber":"1","expirationDate":"3263-04-20T00:00:00","deliveryDate":"2641-06-10T00:00:00","credit":100,"isPayOff":false,"lostCard":false,"replicaCard1":false,"replicaCard2":false,"replicaCard3":false,"isLogin":true,"lastLoginDate":"2021-03-02T14:31:05.997","lastLoginIp":"::1","isActive":true,"reasonDeactivated":"0","roomId":2,"roleId":1,"subGroupId":1,"collageId":2,"fieldId":1,"gradeId":1,"workUnitId":null,"description":null,"id":22}"


  // console.log("333 userData" + JSON.stringify(userData))
  const messagesCount = 0;
  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }
    history.push("/logout");
  };

  const userProfile = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }
    // history.push(`/persons/${userData.id}/editMe`);
    history.push(`/user-profile`);
  };

  return (
    <div id="kt_quick_user" className="offcanvas offcanvas-left offcanvas p-10">
      <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
        <h3 className="font-weight-bold m-0">
          <FormattedMessage id="USER.PROFILE" />
          <small className="text-muted font-size-sm ml-2">
            {" "}
            <FormattedMessage
              id="USER.MESSAGE.COUNT"
              values={{ COUNT: `${messagesCount}` }}
            />
          </small>
        </h3>
        <a
          href="#"
          className="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i className="ki ki-close icon-xs text-muted" />
        </a>
      </div>

      <div className="offcanvas-content pr-5 mr-n5">
        <div className="d-flex align-items-center mt-5">
          <div className="symbol symbol-100 mr-5">
            <div
              className="symbol-label"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/users/blank.png"
                )})`,
              }}
            />
            <i className="symbol-badge bg-success" />
          </div>
          <div className="d-flex flex-column">
            <a
              href="#"
              className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
            >
              {userData.roleTitle}<br></br>
              {userData.firstName}&nbsp;{userData.lastName}
            </a>
            <div className="text-muted mt-1">
              {userData.groupTitle}&nbsp;{userData.subGroupTitle}
              {/* <FormattedMessage
                id="USER.GROUPNAME"
                values={{ NAME: `${groupName}` }}
              />
            <br></br>
              <FormattedMessage
                id="USER.SUBGROUPNAME"
                values={{ NAME: `${subGroupName}` }}
              /> */}
            </div>
            <div className="navi mt-2">
              <a href="#" className="navi-item">

                <span className="navi-link p-0 pb-2">
                  <span className="navi-icon mr-1">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Shopping/Ticket.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    {userData.idNumber}
                  </span>
                </span>

                <span className="navi-link p-0 pb-2">
                  <span className="navi-icon mr-1">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Phone.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    {userData.mobile}
                  </span>
                </span>
                <span className="navi-link p-0 pb-2">
                  <span className="navi-icon mr-1">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Half-star.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    {userData.score}
                  </span>
                </span>



                <span className="navi-link p-0 pb-2">
                  <span className="navi-icon mr-1">
                    <span className="svg-icon-lg svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Code/Time-schedule.svg"
                        )}
                      ></SVG>
                    </span>
                  </span>
                  <span className="navi-text text-muted text-hover-primary">
                    <FormattedTime day="2-digit" month="2-digit" year="numeric" formatMather="YYYY/MM/DD" value={userData.lastLoginDate} />

                  </span>
                </span>
              </a>
            </div>

            <div className="navi mt-10 ">
              <button
                className="btn btn-primary btn-bold px-7 py-3 "
                onClick={userProfile}
              >
                <FormattedMessage id="MODULES.GENERAL.BUTTONEDIT" />
              </button>
              <button
                className="btn btn-light-primary btn-bold ml-2 px-7 py-3"
                onClick={logoutClick}
              >
                <FormattedMessage id="AUTH.GENERAL.LOGOUT" />
              </button>

            </div>
          </div>
        </div>

        {/* <div className="separator separator-dashed mt-8 mb-5" /> */}

        {/* <a href={`/persons/${userData.id}/edit`} className="navi-item"> */}
        {/* <div className="navi navi-spacer-x-0 p-0">
          <a href="" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light mr-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-success">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/General/Notification2.svg"
                      )}
                    ></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">
                  <FormattedMessage id="USER.ACCOUNTSETTING" />
                </div>
                <div className="text-muted">
                  <FormattedMessage id="USER.ACCOUNTSETTING" />{" "}
                  <span className="label label-light-danger label-inline font-weight-bold">
                    <FormattedMessage id="USER.UPDATE" />
                  </span>
                </div>
              </div>
            </div>
          </a> */}

        {/* <a href="/user/profile" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light mr-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-warning">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Shopping/Chart-bar1.svg"
                      )}
                    ></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="font-weight-bold">
                  <FormattedMessage id="USER.MYMESSAGE" />
                </div>
                <div className="text-muted">
                  <FormattedMessage id="USER.MYMESSAGE" />
                </div>
              </div>
            </div>
          </a>
        </div> */}

        {/* <div className="separator separator-dashed my-7"></div> */}
      </div>
    </div>
  );
}
